var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSplit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9993 0.49V7.51C19.9993 7.95 19.4693 8.16 19.1593 7.86L18.1793 6.87C18.0793 6.77 18.0293 6.64 18.0293 6.51V3.39L10.9993 10.41V19.5C10.9993 19.78 10.7793 20 10.4993 20H9.49927C9.21927 20 8.99927 19.78 8.99927 19.5V10.42L1.96927 3.39V6.51C1.96927 6.65 1.91927 6.78 1.81927 6.87L0.839268 7.86C0.529268 8.16 -0.000732422 7.95 -0.000732422 7.51V0.49C-0.000732422 0.22 0.219268 0 0.489268 0H7.50927C7.94927 0 8.15927 0.53 7.85927 0.84L6.85927 1.83C6.76927 1.92 6.64927 1.97 6.51927 1.97H3.38927L9.99927 8.58L16.6093 1.97H13.4793C13.3493 1.97 13.2293 1.92 13.1393 1.83L12.1393 0.84C11.8393 0.53 12.0493 0 12.4893 0H19.5093C19.7793 0 19.9993 0.22 19.9993 0.49Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSplit);
export default __webpack_public_path__ + "static/media/IconSplit.4a2c69fdaedffebf0b268cfc938a69fa.svg";
export { ForwardRef as ReactComponent };